<!-- Base logic for accordion. Do not style this! -->

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    expanded: boolean
    showIcon?: boolean
    animate?: boolean
  }>(),
  { showIcon: true, animate: true },
)
const emit = defineEmits<{ (e: 'accordionToggle', state: boolean): void }>()
const htmlId = Math.round(Math.random() * 1000000)

function onToggle() {
  emit('accordionToggle', !props.expanded)
}
</script>

<template>
  <div
    class="accordion-base"
    :class="{
      'accordion-base--expanded': expanded,
      'accordion-base--animate': animate,
    }"
  >
    <!-- Title -->
    <button
      v-bind-once="{
        'id': `accordion-base-header-${htmlId}`,
        'aria-controls': `accordion-base-panel-${htmlId}`,
      }"
      :aria-expanded="expanded"
      class="accordion-base__header"
      @click.prevent="() => onToggle()"
    >
      <slot name="title" />
      <div v-if="showIcon" aria-hidden="true">
        <slot name="icon" />
      </div>
    </button>

    <!-- Panel -->
    <section
      v-bind-once="{
        'aria-labelledby': `accordion-base-header-${htmlId}`,
      }"
      class="accordion-base__panel"
      :aria-hidden="!expanded"
      :data-animate="animate"
    >
      <div>
        <slot name="content" />
      </div>
    </section>

    <slot name="divider" />
  </div>
</template>

<style scoped lang="scss">
.accordion-base {
  $root: &;
  position: relative;

  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: var(--spacing-xs);
  }

  &__panel {
    display: grid;
    grid-template-rows: 0fr;

    #{$root}--animate & {
      transition: grid-template-rows 500ms;
    }

    #{$root}--expanded & {
      grid-template-rows: 1fr;
    }

    > div {
      overflow: hidden;
    }
  }
}
</style>
